import { RegionShared } from "@1games-ru/region-shared";
import { EstateComplexGarageShowRequest } from "@1games-ru/region-shared/dist/cef/requests/estate";
import { useCallback, useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";

export function useShowVehicleSpawn() {
  const [estateComplexId, setEstateComplexId] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => {
    GameMpProvider.closeCurrentInterface(true);
  }, []);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Estate.EstateComplexGarageShow,
      (response: EstateComplexGarageShowRequest) => {
        setEstateComplexId(response.estateComplexId);
        setIsOpen(true);
      },
    );

    rpc.register(RegionShared.Cef.Events.Estate.EstateComplexGarageHide, () => setIsOpen(false));

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateComplexGarageShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateComplexGarageHide);
    };
  }, []);

  return { isOpen, close, estateComplexId };
}
